import { render, staticRenderFns } from "./Bank branches.vue?vue&type=template&id=68c71c3a&scoped=true"
import script from "./Bank branches.vue?vue&type=script&lang=js"
export * from "./Bank branches.vue?vue&type=script&lang=js"
import style0 from "./Bank branches.vue?vue&type=style&index=0&id=68c71c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c71c3a",
  null
  
)

export default component.exports